import { render, staticRenderFns } from "./AccountTree.vue?vue&type=template&id=4b19eabf&"
import script from "./AccountTree.vue?vue&type=script&lang=ts&"
export * from "./AccountTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports